import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES } from '@/i18n/config';

/**
 * Reads the language prefix from the current URL (not from i18n state).
 * This prevents link stacking when localStorage caches a non-English language.
 */
export const useLocalizedPath = () => {
  const location = useLocation();

  const localePath = useCallback(
    (path: string) => {
      // Extract first segment from current URL
      const firstSegment = location.pathname.split('/')[1] || '';
      const isLangPrefixed = (SUPPORTED_LANGUAGES as readonly string[]).includes(firstSegment);

      if (!isLangPrefixed) return path;
      return `/${firstSegment}${path}`;
    },
    [location.pathname]
  );

  return { localePath };
};
